import { render, staticRenderFns } from "./question-editor.vue?vue&type=template&id=8a7efb54&scoped=true"
import script from "./question-editor.vue?vue&type=script&lang=js"
export * from "./question-editor.vue?vue&type=script&lang=js"
import style0 from "./question-editor.vue?vue&type=style&index=0&id=8a7efb54&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7efb54",
  null
  
)

export default component.exports